import React from 'react';
import { TranslationProvider } from '~contexts/TranslationContext';
import { Provider as ChakraUiProvider } from '~components/ui/provider';
import { Box } from '@chakra-ui/react';

interface PropsTypeInterface {
  pageContext: PageContextInterface;
}

function RenderReactApp(
  props: PropsType<PropsTypeInterface & { loading: boolean }>,
): ReactRenderType {
  return (
    <Box style={{ display: props.loading ? 'none' : 'block' }}>
      {props.children}
    </Box>
  );
}

function App(props: PropsType<PropsTypeInterface>): ReactRenderType {
  return (
    <ChakraUiProvider>
      <TranslationProvider>
        <RenderReactApp {...props} />
      </TranslationProvider>
    </ChakraUiProvider>
  );
}

export default App;
